const styles = {
    background: {
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1900,
        position: 'relative',
    },
    container: {
        padding: props => (props.fullScreen ? '0px' : '0 20px'),
        boxSizing: 'border-box',
        width: props => (props.fullScreen ? '90vw' : '90%'),
        height: props => (props.fullScreen ? '100vh' : '100%'),
        maxWidth: props => (props.fullScreen ? '100vw' : '1341px'),
        maxHeight: props => (props.fullScreen ? '100vh' : '824px'),
        userSelect: 'none',
        zIndex: 2000,
        position: 'relative',
        '@media screen and (max-width : 1200px)': {
            background: '#FFFFFF',
            width: '100vw',
            height: '100vh',
            border: '0px',
        },
    },
    modalClose: {
        border: 'none',
        background: 'none',
        paddingTop: '10px',
        cursor: 'pointer',
        zIndex: 2000,
        float: 'right',
        display: props => (props.fullScreen ? 'none' : 'block'),
    },

    carousel: {
        height: '137px',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 100%)',
        overflowX: 'scroll',
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '& > :last-child': {
            marginRight: '24px',
        },
        '@media screen and (max-width : 1200px)': {
            display: 'none',
        },
    },
    mediaHighlight: {
        border: '3px solid #085FE5',
    },
    imgContainer: {
        display: 'inline-block',
        position: 'relative',
    },
    darkBackground: {
        backgroundColor: 'rgba(0,0,0,0.8)',
        width: '100vw',
        height: '100vh',
        position: 'fixed',
        zIndex: 1899,
        top: 0,
    },
    carouselImgButton: {
        border: 'none',
        background: 'none',
        marginLeft: '24px',
    },
    img: {
        height: '98px',
        width: '160px',
        cursor: 'pointer',
        display: 'inline-block',
        boxSizing: 'border-box',
        objectFit: 'cover',
        outline: 0,
    },
    leftArrow: {
        border: 'none',
        background: 'none',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        height: '24px',
        width: '24px',
        backgroundColor: '#085FE5',
        position: 'absolute',
        left: '-0.8%',
        borderRadius: '50%',
        zIndex: 10000,
        transform: 'rotate(180deg)',
    },
    rightArrow: {
        border: 'none',
        background: 'none',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        height: '24px',
        width: '24px',
        backgroundColor: '#085FE5',
        position: 'absolute',
        right: '-2.5%',
        borderRadius: '50%',
        zIndex: 10000,
    },
    thumbnailIcon: {
        position: 'absolute',
        bottom: '10%',
        right: '5%',
    },
}

export default styles
